import { Utils } from '../../common';
import { api } from '../../api/Axios';

const submitPasswordReset = (email) => {
  const resource = 'Manage/ResetPassword';
  const data = { email };
  return api.post(resource, data);
};


const submitPerformPasswordReset = (newPassword) => {
  const resource = 'Manage/PerformPasswordReset';

  const {
    email: forUserId,
    token: passwordResetToken,
  } = Utils.parse(window.location.search);

  const data = {
    passwordResetToken,
    forUserId,
    newPassword,
  };

  return api.post(resource, data);
};

export default { submitPasswordReset, submitPerformPasswordReset };
